<template>
  <div class="flex-wrapper">
    <div ref="ingredientListWrapper" class="ingredientListWrapper">
      <div
        class="gradient top"
        v-if="overflown"
        :style="{ opacity: gradient_top_opacity }"
      ></div>
      <div
        class="gradient bottom"
        v-if="overflown"
        :style="{ opacity: gradient_bottom_opacity }"
      ></div>
      <div
        class="ingredientList"
        :class="{ 'ingredientList-isV2EditOrder': isEdit && isV2EditOrder() }"
        ref="ingredientsListElem"
      >
        <template v-for="(ingredient, index) in ingredients">
          <div
            v-if="!ingredient.hide"
            :key="ingredientgroup.id + '-' + ingredient.id + '-' + index"
            :style="{
              animationDelay: delay[index]
            }"
            class="itemBox animate"
            :class="{ soldout: ingredient.soldout }"
            @click="change(ingredient)"
          >
            <img class="itemImg" :src="ingredient.image" />

            <div>
              <div
                class="itemCheckBox itemCheckBox-type1"
                v-if="ingredientgroup.type === 1"
              >
                <label @click.prevent class="control control-checkbox">
                  <input
                    :checked="ingredient.count === 1 || ingredient.selected"
                    type="checkbox"
                    @click.self.prevent="change(ingredient)"
                  />
                  <div class="control_indicator"></div>
                </label>
              </div>

              <div
                class="itemCheckBox itemCheckBox-type0"
                v-else-if="ingredientgroup.type === 0"
              >
                <label @click.prevent class="control control-radio ">
                  <input
                    :checked="ingredient.count === 1 || ingredient.selected"
                    type="radio"
                    @click.self.prevent="change(ingredient)"
                  />
                  <div class="control_indicator"></div>
                </label>
              </div>

              <div class="itemCheckBox" v-else-if="ingredientgroup.type === 2">
                <counter-widget
                  @change="changeTo"
                  :group="ingredientgroup"
                  :ingredient="ingredient"
                  :bus="counter_widget_bus"
                ></counter-widget>
              </div>
            </div>

            <div class="itemName text">
              {{
                getTranslation(
                  $store,
                  "Ingredient",
                  "display_name",
                  ingredient.id,
                  ingredient.name
                )
              }}
            </div>
            <div
              class="itemPrice"
              :class="{
                'itemPrice-isSelected':
                  ingredient.selected || ingredient.count > 0
              }"
            >
              <span v-if="!ingredient.soldout">{{ price(ingredient) }}</span>
              <span v-else>{{ $t("menu.soldout") }}</span>
            </div>

            <div
              class="whiteBg"
              :class="{
                selectedBg: ingredient.selected || ingredient.count > 0
              }"
            ></div>
          </div>
        </template>
      </div>
    </div>

    <div
      class="ButtonContainer"
      v-if="!isEdit || isEditIngredientLayer"
      ref="buttonContainer"
    >
      <div class="Button ButtonCancel" @click="back">
        {{ $t(`ingredient.wizard.back`) }}
      </div>
      <div
        class="Button ButtonConfirm"
        @click="goOn"
        :class="{
          ButtonDisabled: disableButtonConfirm
        }"
      >
        {{
          seenAllTabs
            ? $t(`ingredient.wizard.done`)
            : $t(`ingredient.wizard.go_on`)
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { toPrintable, toCalculatable } from "@/utils/pricing";
import { getTranslation } from "@/utils/helpers";
import CounterWidget from "./counterWidget";
import Vue from "vue";
import { smoothScroll } from "@/utils/smoothScrool";
import { isV2EditOrder } from "@/utils/templateSettings";
import { mapGetters } from "vuex";

export default {
  name: "IngredientV2Widget",
  components: { CounterWidget },
  computed: {
    disableButtonConfirm() {
      return this.disableProceed || this.disableProceedByMinCount;
    },
    disableProceedByMinCount() {
      return this.ingredients_selected_count < this.ingredientgroup.min_count;
    },
    count() {
      return this.ingredientgroup.ingredients.length;
    },
    ingredients() {
      return this.ingredientgroup.ingredients.map(ingredient => {
        return { ...ingredient, ...this.itemsDict[ingredient.id] };
      });
    },
    ingredients_selected_count() {
      let count = 0;
      this.ingredientgroup.ingredients.forEach(ing => {
        count += ing.count;
      });
      return count;
    },
    add_base_price() {
      return (
        this.ingredients_selected_count >=
        this.ingredientgroup.price_included_count
      );
    },
    ...mapGetters({
      itemsDict: "ITEMS_DICT"
    })
  },
  data() {
    return {
      overflown: false,
      gradient_top_opacity: 1.0,
      gradient_bottom_opacity: 1.0,
      counter_widget_bus: new Vue(),
      internal_height: 800,
      delay: []
    };
  },
  methods: {
    isV2EditOrder,
    goOn() {
      if (this.disableButtonConfirm) {
        console.log("ingredient v2 widget proceed disabled");
      } else {
        console.log("ingredient v2 widget emits proceed");
        this.$emit("proceed");
      }
    },
    back() {
      console.log("ingredient v2 widget emits back");
      this.$emit("back");
    },
    getTranslation,
    toPrintable,
    toCalculatable,
    changeTo({ ingredient, count }) {
      let old_count = this.ingredientgroup.ingredients.find(
        ing => ing.id === ingredient.id
      ).count;
      if (
        count > old_count &&
        this.ingredientgroup.max_count &&
        this.ingredients_selected_count >= this.ingredientgroup.max_count
      ) {
        return;
      }
      this.$emit("change", {
        group: this.ingredientgroup,
        ingredient,
        count
      });
      this.counter_widget_bus.$emit("added", {
        id: ingredient.id,
        group_id: this.ingredientgroup.id,
        count: count
      });
    },
    change(ingredient) {
      if (ingredient.soldout) return;
      if (this.ingredientgroup.type === 0) {
        this.ingredientgroup.ingredients.forEach(ing => {
          console.log("change ingredientgroup type 'select one'");
          if (ingredient.id === ing.id) {
            this.$emit("change", {
              group: this.ingredientgroup,
              ingredient: ing,
              count: 1
            });
          } else if (ing.count > 0) {
            this.$emit("change", {
              group: this.ingredientgroup,
              ingredient: ing,
              count: 0
            });
          }
        });
      }
      if (this.ingredientgroup.type === 1) {
        if (
          ingredient.count === 0 &&
          this.ingredientgroup.max_count &&
          this.ingredients_selected_count >= this.ingredientgroup.max_count
        ) {
          return;
        }
        this.$emit("change", {
          group: this.ingredientgroup,
          ingredient,
          count: ingredient.count === 1 ? 0 : 1
        });
      }
      if (this.ingredientgroup.type === 2) {
        if (ingredient.count >= ingredient.max_count) return;
        if (
          this.ingredientgroup.max_count &&
          this.ingredients_selected_count >= this.ingredientgroup.max_count
        ) {
          return;
        }
        this.$emit("change", {
          group: this.ingredientgroup,
          ingredient,
          count: ingredient.count + 1
        });
        this.counter_widget_bus.$emit("added", {
          id: ingredient.id,
          group_id: this.ingredientgroup.id,
          count: ingredient.count + 1
        });
      }
    },
    price(ingredient) {
      let ing_price = toCalculatable(ingredient.price);
      if (this.add_base_price) {
        ing_price += toCalculatable(
          this.ingredientgroup.price_included_baseprice
        );
      }
      if (ing_price === 0.0) return "";
      return `${toPrintable(ing_price, true)}`;
    },
    checkOverflown() {
      if (this.isEdit && this.isV2EditOrder()) {
        return;
      }
      if (typeof this.$refs.ingredientsListElem === "undefined") {
        this.overflown = false;
        return;
      }
      let elem = this.$refs.ingredientsListElem;
      elem.removeEventListener("scroll", this.scroll);
      this.overflown = elem.scrollHeight > elem.clientHeight;
      if (this.overflown) {
        elem.addEventListener("scroll", this.scroll);

        this.gradient_bottom_opacity = 1.0;
        this.gradient_top_opacity = 1.0;
        setTimeout(() => {
          this.scroll(undefined);
          this.scrollBottomToTop();
        }, 0);
      }
      this.$refs.ingredientsListElem.scrollTo(0, 0);
    },
    scroll(event) {
      let elem = this.$refs.ingredientsListElem;
      let distance_from_bottom =
        elem.scrollHeight - (elem.clientHeight + elem.scrollTop);
      let bottom_multiplier =
        distance_from_bottom > 300 ? 1.0 : distance_from_bottom + 1 / 300.0;
      this.gradient_bottom_opacity = bottom_multiplier;
      let top_multiplier =
        elem.scrollTop > 300 ? 1.0 : elem.scrollTop + 1 / 300.0;
      this.gradient_top_opacity = top_multiplier;
    },
    scrollBottomToTop() {
      const TIMEOUT_BEFORE_SCROLL_START = 250;
      const SCROLL_DURATION = 1250;
      let ingredientsDiv = this.$refs.ingredientsListElem;
      let scrollTo = ingredientsDiv.scrollHeight - ingredientsDiv.clientHeight;
      ingredientsDiv.scrollTop = scrollTo;
      setTimeout(() => {
        smoothScroll(0, SCROLL_DURATION, ingredientsDiv);
      }, TIMEOUT_BEFORE_SCROLL_START);
    },
    setDelay(ingredients) {
      console.log("set anmimation delay for ingredients");
      this.delay = [];
      ingredients.forEach((ingredient, index) => {
        this.delay.push(index * 20 + "ms");
      });
      if (!this.isV2EditOrder()) {
        if (this.delay.length > 12) {
          this.delay.reverse();
        }
      }
    }
  },
  watch: {
    ingredients(newVal, oldVal) {
      this.$emit(
        "disableProceedByMinCount",
        this.ingredients_selected_count < this.ingredientgroup.min_count
      );
      if (oldVal.length !== newVal.length) {
        this.setDelay(newVal);
      }
    },
    activeGroupIdx() {
      setTimeout(this.checkOverflown, 0);
    },
    height(newHeight) {
      //setTimeout(this.checkOverflown, 0);
      this.internal_height = newHeight;
    }
  },
  created() {
    this.setDelay(this.ingredientgroup.ingredients);
    if (this.height) {
      this.internal_height = this.height;
    }
    setTimeout(this.checkOverflown, 0);
  },
  props: {
    disableProceed: Boolean,
    isEdit: Boolean,
    isEditIngredientLayer: {
      type: Boolean,
      default: false
    },
    seenAllTabs: Boolean,
    ingredientgroup: Object,
    height: Number,
    activeGroupIdx: Number
  }
};
</script>

<style scoped lang="scss">
@keyframes itemBoxIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.flex-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
}

.ingredientList .control_indicator {
  position: relative;
}

.ButtonContainer {
  display: flex;
  justify-content: space-between;
  margin-inline: 35px;
  /* see backAndConfirmButtonsHeight */
  height: var(--component_ingredientV2Widget_ButtonContainer_height);
  padding-top: var(--component_ingredientV2Widget_ButtonContainer_padding-top);
  .Button {
    border: var(--component_ingredientV2Widget_ButtonContainer_Button_border);
    border-radius: var(
      --component_ingredientV2Widget_ButtonContainer_Button_border-radius
    );
    display: flex;
    font-family: var(
      --component_ingredientV2Widget_ButtonContainer_Button_font-family
    );
    font-size: var(
      --component_ingredientV2Widget_ButtonContainer_Button_font-size
    );
    height: var(--component_ingredientV2Widget_ButtonContainer_Button_height);
    justify-content: center;
    letter-spacing: 2px;
    padding: var(--component_ingredientV2Widget_ButtonContainer_Button_padding);
    text-transform: var(
      --component_ingredientV2Widget_ButtonContainer_Button_text-transform
    );
    width: var(--component_ingredientV2Widget_ButtonContainer_Button_width);
    z-index: 10;
  }

  .ButtonCancel {
    background: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonCancel_background
    );
    color: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonCancel_color
    );
    left: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonCancel_left
    );
    border: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonCancel_border
    );
  }

  .ButtonConfirm {
    background: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonConfirm_background
    );
    color: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonConfirm_color
    );
    right: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonConfirm_right
    );
    border: var(
      --component_ingredientV2Widget_ButtonContainer_Button_ButtonConfirm_border
    );
  }
  .ButtonDisabled {
    background: #cfcfcf;
    border: var(--app_button-outlined_border-width) solid #cfcfcf;
    opacity: 0.35;
  }
}

.itemCheckBox {
  display: flex;
  justify-content: center;
  z-index: 1;
}

.itemCheckBox-type0 {
  visibility: var(--component_ingredientV2Widget_itemCheckBox-type0_visibility);
}

.itemCheckBox-type1 {
  visibility: var(--component_ingredientV2Widget_itemCheckBox-type1_visibility);
}

.ingredientListWrapper {
  flex-shrink: 1;
  overflow: scroll;
  background: var(
    --component_ingredientV2Widget_ingredientListWrapper_background
  );
  box-shadow: var(
    --component_ingredientV2Widget_ingredientListWrapper_box-shadow
  );
  display: flex;
  justify-content: center;
  margin: var(--component_ingredientV2Widget_ingredientListWrapper_margin);
  position: relative;
}

.ingredientList {
  width: 940px;
  background: var(--component_ingredientV2Widget_ingredientList_background);
  box-shadow: var(--component_ingredientV2Widget_ingredientList_box-shadow);
  overflow: scroll;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: min-content;
  gap: 20px;
}

.ingredientList-isV2EditOrder {
  overflow: unset;
}

.itemBox {
  //height: var(--component_ingredientV2Widget_itemBox_height);
  width: 100%;
  margin: 0;
  text-align: center;
  opacity: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}

.itemBox.soldout .itemPrice {
  font-size: 14px;
}

.itemBox.soldout .itemImg {
  opacity: 0.12;
}

.itemBox.animate {
  animation: itemBoxIn 500ms forwards ease;
}

.itemImg {
  //margin-top: 40px;
  //margin-bottom: 10px;
  width: 100%;
  aspect-ratio: 2.2;
  object-fit: contain;
}

.itemName {
  color: var(--component_ingredientV2Widget_itemName_color);
  margin-top: 8px;
  letter-spacing: var(--app_letter-spacing_dense);
  text-transform: var(--component_ingredientV2Widget_itemName_text-transform);
  font-family: var(--component_ingredientV2Widget_itemName_font-family);
  font-size: var(--component_ingredientV2Widget_itemName_font-size);
  font-weight: var(--component_ingredientV2Widget_itemName_font-weight);
  text-align: var(--component_ingredientV2Widget_itemName_text-align);
  padding: var(--component_ingredientV2Widget_itemName_padding);
  flex-grow: 1;
}

.itemPrice {
  letter-spacing: 0;
  color: var(--component_ingredientV2Widget_itemPrice_color);
  font-family: var(--component_ingredientV2Widget_itemPrice_font-family);
  font-size: var(--component_ingredientV2Widget_itemPrice_font-size);
  margin-bottom: 15px;
  text-align: var(--component_ingredientV2Widget_itemPrice_text-align);
  padding: var(--component_ingredientV2Widget_itemPrice_padding);
  height: 20px;
}

.itemPrice-isSelected {
  color: var(--component_ingredientV2Widget_itemPrice-isSelected_color);
}

.whiteBg {
  position: absolute;
  width: 100%;
  height: calc(100% - 66px);
  background: var(--component_ingredientV2Widget_whiteBg_background);
  border-radius: var(--component_common_ItemList_whiteBg_border-radius);
  box-shadow: var(--component_ingredientV2Widget_whiteBg_box-shadow);
  bottom: 0px;
  z-index: -1;
}

.selectedBg {
  background: var(--component_ingredientV2Widget_selectedBg_background);
}

.gradient {
  transition: opacity 0.5s ease;
  z-index: 5;
  position: absolute;
  pointer-events: none;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gradient.top {
  top: var(--component_ingredientV2Widget_gradient_top_top);
  background: var(--component_ingredientV2Widget_gradient_top_background);
}

.gradient.bottom {
  bottom: var(--component_ingredientV2Widget_gradient_bottom_bottom);
  background: var(--component_ingredientV2Widget_gradient_bottom_background);
}
</style>
